import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { logAction } from '../../../shared/lib/userLogger';

export function useCardModalStore() {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedLeadId = searchParams.get('card');
  const isOpen = Boolean(selectedLeadId);

  const openModal = useCallback((id: string, title?: string) => {
    logAction(`Viewed card: ${title || id}`, 'VIEW');
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.set('card', id);
      return next;
    }, { replace: false });
  }, [setSearchParams]);

  const closeModal = useCallback(() => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.delete('card');
      return next;
    }, { replace: true });
  }, [setSearchParams]);

  return { isOpen, selectedLeadId, openModal, closeModal };
}
